module.exports = __webpack_public_path__ + "media/images/result_sets/circles/9r1n3r6r-561a1aa70818640f2d4f1dba77059741.svg";